export default __webpack_public_path__ + "scripts/resources/assignments/en/chemvlab/thermodynamics/Thiocyanate/spectra.json";